import { Euler } from "three"
import * as CANNON from 'cannon-es'
import { ballMass, moveEvent } from "../../constants"
import WorldSocket from "../sockets/WorldSocket"

export default class WorldBall {
  constructor(world, material) {
    this.world = world

    this.shape = new CANNON.Sphere(1.5)
    this.body = new CANNON.Body({ material, mass: ballMass })
    this.body.addShape(this.shape)

    this.bindToMesh = this.bindToMesh.bind(this)

    this.world.addBody(this.body)

    this.listenLaunch()

    this.listenMove()
  }

  bindToMesh({ mesh }) {
    this.mesh = mesh
    this.body.position.set(this.mesh.position.x, mesh.position.y, mesh.position.z)
  }

  listenLaunch() {
    window.addEventListener('click', (x, y, z) => {
        this.launch(x, y, z)
    })
  }

  launch(x, y, z) {
    this.body.velocity.set(0, 0, -40)
  }

  listenMove() {
    WorldSocket.onMessage(moveEvent, data => {
      this.body.velocity.set(data.x, data.y, data.z)
    })
  }

  update() {
    this.mesh.position.set(this.body.position.x, this.body.position.y, this.body.position.z)
    const rotation = new CANNON.Vec3(0,0,0)
    this.body.quaternion.toEuler(rotation, 'YZX')
    this.mesh.setRotationFromEuler(new Euler(...Object.values(rotation), 'YZX'))
  }
}